import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from 'react-bootstrap/Button';

// Locale
import messages from '../../../locale/messages';

class Logout extends React.Component {
  static defaultProps = {
      actionUrl: '/logout'
  };

  render() {
    const { containerClass, formClass, buttonClass, actionUrl, children } = this.props;

    return (
      <div className={containerClass}>
        <form action={actionUrl} method="post" className={formClass}>
          <Button type="submit" variant="link" className={buttonClass}>
            {children}
          </Button>
        </form>
      </div>
    );
  }

}

export default Logout;
